import { Row } from "routes/patients/PatientProfile/components/Information/components/Rows";
import { SkeletonLayout } from "shared/atoms/SkeletonLayout";

const leftWidthOptions = ["25%", "35%", "30%"];
const rightWidthOptions = ["15%", "25%", "20%"];

export const SkeletonRows = () => {
  return (
    <>
      {Array.from({ length: 10 }).map((_, index) => {
        const leftWidth = leftWidthOptions[index % leftWidthOptions.length];
        const rightWidth = rightWidthOptions[index % rightWidthOptions.length];

        return (
          <Row
            // eslint-disable-next-line react/no-array-index-key
            key={`skeleton-${index}`}
            left={<SkeletonLayout layout={{ type: "skeleton", variant: "text", width: leftWidth }} />}
            right={<SkeletonLayout layout={{ type: "skeleton", variant: "text", width: rightWidth }} />}
          />
        );
      })}
    </>
  );
};
